/** Default SMS/push copy shown (and editable) in the send dialog. The backend
 * holds the canonical default too, so an omitted `message` is still safe; this is
 * only the pre-filled starting point the admin can tweak. */
export const DEFAULT_INVITE_MESSAGE = "Qwick: Finish setting up your profile with a quick AI interview (~5 min):";

/** Upper bound on the editable portion so the total stays in a sane SMS-segment
 * range once the link is appended. The backend enforces its own limit (returns a
 * 400); this is the client-side pre-check + live counter. */
export const MESSAGE_MAX_LENGTH = 300;

/** Host of the invite URL surfaced in the preview. The real link is minted by the
 * vendor and appended server-side — this is a display-only stub for the bubble. */
export const INTERVIEW_LINK_PREVIEW = "interview.qwick.com/i/…";

/** Rough length the appended link adds, for the live "+ link ≈ N" counter. */
export const APPENDED_LINK_LENGTH = 28;
